import postProcessResolvedDiscoveryRow, {} from "./postProcessResolvedDiscoveryRow";
export default function publishRows(rows, blockedCreatorIds, accessors) {
    return rows.map((row) => {
        if (row.status !== "success")
            return row;
        const items = postProcessResolvedDiscoveryRow(row.block.key, row.items, blockedCreatorIds, accessors);
        if (items === row.items)
            return row;
        if (items.length === 0)
            return { status: "empty", block: row.block };
        return { ...row, items };
    });
}
